import { initializeApp } from 'firebase/app';
import { getAuth } from "firebase/auth";

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
    authDomain: `${import.meta.env.VITE_FIREBASE_PROJECT_ID || ''}.firebaseapp.com`,
    databaseURL: `https://${import.meta.env.VITE_FIREBASE_PROJECT_ID || ''}.firebaseio.com`,
    storageBucket: `${import.meta.env.VITE_FIREBASE_PROJECT_ID || ''}.appspot.com`,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export default {app, auth};